import lodash from 'lodash';

import { getStringValue } from 'common/util/dataTypeValues';

/**
 * Separates study metadata values that were combined 
 * to be displayed in the workflow under a single input.
 * Also transforming the format of the value field back to 
 * just a string.
 * Note: The data transformation step should be moved to the component
 * @param {Array<StudyMetadata>} studyMetadata 
 * @param {String} type The type of study metadata [study | binder]
 * @returns {{[descriptorId]: Array<StudyMetadata>}}
 */
export function separateMetadataValues(studyMetadata = [], type, groupByKey) {
    return lodash.chain(studyMetadata)
        .flatMap(studyMetadata => {
            if (!lodash.isNil(studyMetadata.value) || !lodash.isEmpty(studyMetadata.value)) {
                const { inputFieldType, dataType, value: metadataValue } = studyMetadata;

                const studyMetadataFieldsToSave = ['name', 'value', 'type', 'dataType',
                    'inputFieldType', 'descriptorId', 'institutionId'];
                if (lodash.isArray(metadataValue)) {
                    return lodash.map(metadataValue, value => ({
                        ...lodash.pick(studyMetadata, studyMetadataFieldsToSave),
                        value: formatMetadataValue(inputFieldType, dataType, value),
                        type,
                    }));
                }
                return {
                    ...lodash.pick(studyMetadata, studyMetadataFieldsToSave),
                    value: formatMetadataValue(inputFieldType, dataType, metadataValue),
                    type
                };
            }
        })
        .compact()
        .groupBy(groupByKey)
        .value();
}

function formatMetadataValue(inputFieldType, dataType, value) {
    const SELECT_INPUT_TYPES = ['single-select', 'multi-select'];
    const metadataValue = SELECT_INPUT_TYPES.includes(inputFieldType) ? value.value : value;

    return getStringValue(dataType, metadataValue);
}
